import { levels } from "./level-config";
import { LevelControllerV2 } from "./v2/level-controller-v2";

const levelController = new LevelControllerV2(onLevelComplete);

let furthestLevelIdxUnlocked = -1;
let curLevelIdx = -1;

// prev and next button handlers...
const prevLevelBtn = document.querySelector('.prev-level-btn');
prevLevelBtn.addEventListener('click', (ev) => {
  if (curLevelIdx <= 0) {
    return;
  }

  curLevelIdx--;

  levelController.disposeCurrentLevel();

  generateLevelAtCurIdx();
});

const nextLevelBtn = document.querySelector('.next-level-btn');
nextLevelBtn.addEventListener('click', (ev) => {
  if (curLevelIdx >= (numTotalLevels-1)) {
    return;
  }

  /*
  if (curLevelIdx === furthestLevelIdxUnlocked) {
    return;
  }
  */

  curLevelIdx++;

  levelController.disposeCurrentLevel();

  generateLevelAtCurIdx();
});

const levelNumEl = document.querySelector('.level-num');

const numTotalLevels = levels.length;


function init() {

  curLevelIdx = 0;
  furthestLevelIdxUnlocked = 0;

  // handle buttons...

  generateLevelAtCurIdx();
}

function generateLevelAtCurIdx() {
  const initialLevel = levels[curLevelIdx];
  levelNumEl.textContent = curLevelIdx+1;
  setSelectorsForCurrentLevel();

  levelController.generateLevel(initialLevel, (curLevelIdx === numTotalLevels-1));
}

function setSelectorsForCurrentLevel() {
  if (curLevelIdx <= 0) {
    prevLevelBtn.disabled = true;
  }
  else {
    prevLevelBtn.disabled = false;

  }

  //if (curLevelIdx >= (numTotalLevels-1)
  //  || curLevelIdx === furthestLevelIdxUnlocked) {
  if (curLevelIdx >= (numTotalLevels-1)) {
    nextLevelBtn.disabled = true;
  }
  else {
    nextLevelBtn.disabled = false;
  }
}

function onLevelComplete() {
  furthestLevelIdxUnlocked = Math.max(
    furthestLevelIdxUnlocked,
    Math.min(numTotalLevels-1, curLevelIdx + 1)
  );

  setSelectorsForCurrentLevel();
}


window.onload = init;